import { useQuery } from '@tanstack/react-query';
import masterServicesAPI from '../../apis/master-services';

export const useConditions = (searchTerm: string) => {
  const { data: conditionsResponse, isFetched: isLoaded, refetch } = useQuery({
    queryKey: ['conditions'],
    queryFn: () => searchConditions(),
    meta: { errorMessage: 'Failed to load conditions list' }
  });

  const total = conditionsResponse?.pagination?.total || 0;
  const conditions = conditionsResponse?.data || [];

  return {
    conditions: conditions || [],
    isLoaded,
    total,
    refetch
  };
};

async function searchConditions() {
  return masterServicesAPI.getServiceConditions({ limit: 50 });
}
